export default __webpack_public_path__ + "static/media/AnalyticalChemistry.91620b99.png";